import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { ManagerWarningType, ManagerWarningTypeNames } from '../../../Enums';
import { formatDateRange, getAsLongDate, getTimeOnly } from '../../../../common-client2/src/services/ukgDateTime';

const ManagerWarningContent = ({ warning, classes }) => {
    const { t } = useTranslation('employmentBillboard');
    const formatDate = (date) => `(${getAsLongDate(date)})`

    const getWarningMessageWithShiftDateTime = (warning) => t(`manager.managerWarnings.${ManagerWarningTypeNames[warning.type]}`, {
        shiftTime: formatDateRange(warning.shift.startDateTime, warning.shift.endDateTime, getTimeOnly),
        shiftDate: formatDate(warning.shift.startDateTime),
    })
    switch (warning.type) {
        case ManagerWarningType.Overlap: //Overlap
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.ShiftInThePast: // Shift In The Past
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.OpenShiftMoreRequestThanShiftsAvailable: // Open Shift More Request Than Shifts Available
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.OpenShiftNotFound: // Open Shift Not Found
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.RestBetweenShift: // Rest Between Shifts
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.ConflictWithOtherRequest: // Conflict With Other Request
            let conflictType = "";
            if (warning.parent.type === ManagerWarningType.Overlap) {
                conflictType = "overlap";
            } else if (warning.parent.type === ManagerWarningType.RestBetweenShift) {
                conflictType = "Rest between shifts";
            }
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {
                    t(`manager.managerWarnings.${ManagerWarningTypeNames[warning.type]}`, {
                        conflictType: conflictType,
                        shiftTime: formatDateRange(warning.shift.startDateTime, warning.shift.endDateTime, getTimeOnly),
                        shiftDate: formatDate(warning.shift.startDateTime)
                    })
                }
            </div>;
        case ManagerWarningType.ShiftNotFound: // Shift not found!
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.SubmissionPeriodEndInFuture: // Submission period ends in the future
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {
                    t(`manager.managerWarnings.${ManagerWarningTypeNames[warning.type]}`)
                }
            </div>;
        case ManagerWarningType.EmployeeNotInHyperfind: // Employee not in hyperfind
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {
                    t(`manager.managerWarnings.${ManagerWarningTypeNames[warning.type]}`, { employeeName: warning.employeeName })
                }
            </div>;
        case ManagerWarningType.AllowedTimeBeforeShift: // Allowed time before shift
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {getWarningMessageWithShiftDateTime(warning)}
            </div>;
        case ManagerWarningType.EmployeeOnRestriction: // Employee on restriction
            return <div className={classes.warningMessage}>
                <FontAwesomeIcon style={{ paddingRight: "5px" }} className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                {
                    t(`manager.managerWarnings.${ManagerWarningTypeNames[warning.type]}`, { employeeName: warning.employeeName, date1: formatDate(warning.fromDate), date2: formatDate(warning.toDate) })
                }
            </div>;
        default:
            return <></>;
    }
}
export default ManagerWarningContent;